import React from "react";
import { Link } from "react-router-dom";
import { Translate, I18n } from "react-redux-i18n";
import { connect } from "react-redux";
import {
  FaEnvelope,
  FaEye,
  FaEyeSlash,
  FaKey,
  FaLock,
  FaSignInAlt,
} from "react-icons/fa";

import "./styles/LoginForm.css";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

import * as actions from "../redux/actions/sessionActions";
import MiniLoader from "../components/MiniLoader";

class LoginForm extends React.Component {
  state = {
    mode: "password",
    codeStep: "email",
    showPassword: false,
    form: { email: "", password: "", code: "" },
    touched: {
      email: false,
      password: false,
      code: false,
    },
  };

  handleChange = (e) => {
    this.setState((prev) => ({
      form: {
        ...prev.form,
        [e.target.name]: e.target.value,
      },
    }));
  };

  handleBlur = (field) => () => {
    this.setState((prev) => ({
      touched: { ...prev.touched, [field]: true },
    }));
  };

  setMode = (mode) => {
    this.setState({
      mode,
      codeStep: "email",
      form: { ...this.state.form, password: "", code: "" },
      touched: { email: false, password: false, code: false },
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    if (this.state.mode === "code") {
      if (this.state.codeStep === "email") {
        this.handleSendCode();
      } else {
        this.handleLoginWithCode();
      }
      return;
    }

    if (
      this.validateField("email") ||
      this.validateField("password") ||
      this.isEmailInvalid()
    ) {
      this.setState({
        touched: { email: true, password: true, code: false },
      });
      return;
    }
    this.fetchLogin();
  };

  fetchLogin = async () => {
    await this.props.LoginRequest(this.state.form).then(() => {
      if (JSON.stringify(this.props.user) === "{}" && this.props.error) {
        alertify.warning(I18n.t(this.props.error));
      } else {
        this.props.history.push("/home");
      }
    });
  };

  handleSendCode = async () => {
    if (this.validateField("email") || this.isEmailInvalid()) {
      this.setState((prev) => ({
        touched: { ...prev.touched, email: true },
      }));
      return;
    }

    const result = await this.props.SendLoginCode({
      email: this.state.form.email,
    });

    if (result?.success) {
      alertify.success(I18n.t("login_code_sent"));
      this.setState({ codeStep: "code" });
      return;
    }

    if (result?.error) {
      alertify.warning(I18n.t(result.error));
    }
  };

  handleLoginWithCode = async () => {
    if (this.validateField("code")) {
      this.setState((prev) => ({
        touched: { ...prev.touched, code: true },
      }));
      return;
    }

    await this.props
      .LoginWithCode({
        email: this.state.form.email,
        code: this.state.form.code,
      })
      .then(() => {
        if (JSON.stringify(this.props.user) === "{}" && this.props.error) {
          alertify.warning(I18n.t(this.props.error));
        } else {
          this.props.history.push("/home");
        }
      });
  };

  togglePassword = () => {
    this.setState((prev) => ({ showPassword: !prev.showPassword }));
  };

  validateField = (field) => {
    return !this.state.form[field] || this.state.form[field].length === 0;
  };

  shouldMarkError = (field) => {
    return this.state.touched[field] && this.validateField(field);
  };

  isEmailInvalid = () => {
    if (!this.state.touched.email) return false;
    const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    return !reg.test(this.state.form.email);
  };

  renderPasswordForm() {
    const emailError = this.shouldMarkError("email") || this.isEmailInvalid();
    const passwordError = this.shouldMarkError("password");

    return (
      <React.Fragment>
        <div className="login-form__field">
          <label className="login-form__label" htmlFor="login_email">
            <Translate value="profile_email" />
          </label>
          <div
            className={`login-form__input-wrap${
              emailError ? " login-form__input-wrap--invalid" : ""
            }`}
          >
            <span className="login-form__input-icon" aria-hidden="true">
              <FaEnvelope />
            </span>
            <input
              id="login_email"
              type="email"
              name="email"
              className="login-form__input"
              placeholder="email@ejemplo.com"
              onChange={this.handleChange}
              onBlur={this.handleBlur("email")}
              value={this.state.form.email}
              autoComplete="email"
              required
            />
          </div>
          {emailError && (
            <p className="login-form__error">
              <Translate value="warning_email_valid" />
            </p>
          )}
        </div>

        <div className="login-form__field">
          <label className="login-form__label" htmlFor="login_password">
            <Translate value="password" />
          </label>
          <div
            className={`login-form__input-wrap${
              passwordError ? " login-form__input-wrap--invalid" : ""
            }`}
          >
            <span className="login-form__input-icon" aria-hidden="true">
              <FaLock />
            </span>
            <input
              id="login_password"
              type={this.state.showPassword ? "text" : "password"}
              name="password"
              className="login-form__input"
              placeholder={I18n.t("password")}
              onChange={this.handleChange}
              onBlur={this.handleBlur("password")}
              value={this.state.form.password}
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="login-form__toggle"
              onClick={this.togglePassword}
              aria-label="Toggle password visibility"
            >
              {this.state.showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          {passwordError && (
            <p className="login-form__error">
              <Translate value="warning_password" />
            </p>
          )}
        </div>

        <p className="login-form__forgot">
          <Link to="/password_forget">
            <Translate value="password_forget" />
          </Link>
        </p>

        <button
          type="submit"
          className="login-form__submit"
          disabled={this.props.loading}
        >
          {this.props.loading ? <MiniLoader /> : <Translate value="login" />}
        </button>
      </React.Fragment>
    );
  }

  renderCodeForm() {
    const emailError = this.shouldMarkError("email") || this.isEmailInvalid();
    const codeError = this.shouldMarkError("code");
    const waitingCode = this.state.codeStep === "code";

    return (
      <React.Fragment>
        <p className="login-form__hint">
          <Translate value="login_code_hint" />
        </p>

        <div className="login-form__field">
          <label className="login-form__label" htmlFor="login_code_email">
            <Translate value="profile_email" />
          </label>
          <div
            className={`login-form__input-wrap${
              emailError ? " login-form__input-wrap--invalid" : ""
            }`}
          >
            <span className="login-form__input-icon" aria-hidden="true">
              <FaEnvelope />
            </span>
            <input
              id="login_code_email"
              type="email"
              name="email"
              className="login-form__input"
              placeholder="email@ejemplo.com"
              onChange={this.handleChange}
              onBlur={this.handleBlur("email")}
              value={this.state.form.email}
              autoComplete="email"
              disabled={waitingCode}
              required
            />
          </div>
          {emailError && (
            <p className="login-form__error">
              <Translate value="warning_email_valid" />
            </p>
          )}
        </div>

        {waitingCode && (
          <div className="login-form__field">
            <label className="login-form__label" htmlFor="login_code">
              <Translate value="login_code_label" />
            </label>
            <div
              className={`login-form__input-wrap${
                codeError ? " login-form__input-wrap--invalid" : ""
              }`}
            >
              <span className="login-form__input-icon" aria-hidden="true">
                <FaKey />
              </span>
              <input
                id="login_code"
                type="text"
                name="code"
                className="login-form__input"
                placeholder="000000"
                inputMode="numeric"
                maxLength="6"
                onChange={this.handleChange}
                onBlur={this.handleBlur("code")}
                value={this.state.form.code}
                autoComplete="one-time-code"
                required
              />
            </div>
            {codeError && (
              <p className="login-form__error">
                <Translate value="login_code_required" />
              </p>
            )}
            <p className="login-form__hint login-form__hint--small">
              <Translate value="login_code_expires_hint" />
            </p>
          </div>
        )}

        <button
          type="submit"
          className="login-form__submit"
          disabled={this.props.loading}
        >
          {this.props.loading ? (
            <MiniLoader />
          ) : waitingCode ? (
            <Translate value="login" />
          ) : (
            <Translate value="login_code_send" />
          )}
        </button>

        {waitingCode && (
          <button
            type="button"
            className="login-form__secondary"
            onClick={() =>
              this.setState({
                codeStep: "email",
                form: { ...this.state.form, code: "" },
              })
            }
          >
            <Translate value="login_code_change_email" />
          </button>
        )}
      </React.Fragment>
    );
  }

  render() {
    const { mode } = this.state;

    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-card__icon" aria-hidden="true">
            <FaSignInAlt />
          </div>

          <header className="login-card__header">
            <h1 className="login-card__title">
              <Translate value="wellcome" />
            </h1>
            <p className="login-card__subtitle">
              <Translate value="joinwinall1" />
            </p>
          </header>

          <div className="login-mode-tabs" role="tablist">
            <button
              type="button"
              role="tab"
              aria-selected={mode === "password"}
              className={`login-mode-tabs__btn${
                mode === "password" ? " is-active" : ""
              }`}
              onClick={() => this.setMode("password")}
            >
              <Translate value="login_with_password" />
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={mode === "code"}
              className={`login-mode-tabs__btn${
                mode === "code" ? " is-active" : ""
              }`}
              onClick={() => this.setMode("code")}
            >
              <Translate value="login_with_code" />
            </button>
          </div>

          <form className="login-form" onSubmit={this.handleSubmit} noValidate>
            {mode === "password"
              ? this.renderPasswordForm()
              : this.renderCodeForm()}
          </form>

          <div className="login-card__links">
            <p>
              <Translate value="password_forget_register" />{" "}
              <Link to="/register">
                <Translate value="register" />
              </Link>
            </p>
          </div>

          <p className="login-card__legal">
            <Translate value="register_tos" />{" "}
            <Link to="/home/terms_condition" target="_blank" rel="noopener noreferrer">
              <Translate value="footer_tos" />
            </Link>{" "}
            <Translate value="and" />{" "}
            <Link to="/home/privacy_politics" target="_blank" rel="noopener noreferrer">
              <Translate value="footer_privacy" />
            </Link>
          </p>
        </div>
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user: reducer.session.auth,
    error: reducer.session.error,
    loading: reducer.session.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoginRequest: (data) => dispatch(actions.loginRequest(data)),
  SendLoginCode: (data) => dispatch(actions.sendLoginCodeRequest(data)),
  LoginWithCode: (data) => dispatch(actions.loginWithCodeRequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
